/*  MUI  */
import { Box } from '@mui/material';

/*  Shared  */
import { Reports } from 'application/Home/Reports/Reports';
import { AdminView, PartnerView } from 'application/Shared/Views';

/*  React  */
import React from 'react';
import { useParams } from 'react-router';

const ReportContent = ({ reportType }) => {
    const { reportType: reportTypeFromParams } = useParams();

    return (
        <Box
            sx={{ '@media print': { padding: '0px !important' } }}
            data-trackid="reportContent"
        >
            <Reports reportType={reportType || reportTypeFromParams} />
        </Box>
    );
};

export const AdminPartnerReportsWrapper = ({ reportType }) => {
    const { clientId } = useParams();

    if (clientId) {
        return (
            <AdminView page="reports">
                <ReportContent reportType={reportType} />
            </AdminView>
        );
    }
    return (
        <PartnerView page="partner_reports">
            <ReportContent reportType={reportType} />
        </PartnerView>
    );
};
